import { createRoute } from '@tanstack/react-router'
import { Chatbot } from '@/pages/Chatbot'
import { Route as rootRoute } from './__root'
import { z } from 'zod'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/chatbot',
  component: Chatbot,
  validateSearch: z.object({
  mode: z.enum(['create', 'edit']).optional(),
  id: z.string().optional(),
  }),
})
